import * as types from '../actiontypes';
import {GetFormValidationsUrl, GetAllValidationsUrl} from '../apiUrls';
import {
	ValidationGroup,
	documentTypes,
	validationFilter,
	formBodyType,
	summaryFilters,
	navigationFilters
} from '../../util/uiconstants';
import Utility from '../../util/utilityfunctions';
import {loadStorage} from '../../components/Common/localStorage';

const commonValidationParams = {
	includeCount: true,
	includeDetail: true
};

//Executes Validations Api (not Forms validations).
//EngagementId: number
//Documents: [{ id: string, documentTypeId: number}];
export const getDocumentValidations = (
	engagementId,
	documents,
	embeddedFormBodyTypeIds = undefined,
	bodyTypeId,
	validationGroup,
	filter = undefined,
	isForDocumentsWithoutApprovals = false
) => {
	if (documents && documents.length > 0) {
		const documentIds = documents?.map((d) => d?.id);
		const documentTypeIds = documents?.map((d) => d?.documentTypeId);
		const validationGroups = getValidationGroups(documentTypeIds, bodyTypeId);

		if (
			validationGroups.length > 0 &&
			((bodyTypeId === formBodyType.ALRAAccountList &&
				validationGroups[0] === ValidationGroup.AccountsWithoutIndividualALRADocument) ||
				(bodyTypeId === formBodyType.DocumentUploadLegend &&
					validationGroups[0] === ValidationGroup.DocumentsMissingRequiredPICEQRSignOff) ||
				(filter &&
					(filter === navigationFilters.INCOMPLETERESPONSES || filter === navigationFilters.UNRESOLVEDCOMMENTS)))
		) {
			commonValidationParams.hasIncompleteResponse = true;
		} else {
			delete commonValidationParams.hasIncompleteResponse;
		}

		if (validationGroup) {
			validationGroups.push(validationGroup);
		}

		const url = GetAllValidationsUrl(engagementId, {
			...commonValidationParams,
			validationGroups,
			filteredDocumentIds: documentIds.join(','),
			embeddedFormBodyTypeIds
		});

		return {
			type: isForDocumentsWithoutApprovals ? types.GET_WITHOUT_APPROVAL_VALIDATION_COUNTS : types.GET_VALIDATIONCOUNTS,
			documentIds,
			meta: {
				api: {
					url,
					method: 'GET'
				}
			}
		};
	}
};

//Executes Validations Api (not Forms validations).
//EngagementId: number
//Documents: [{ id: string, documentTypeId: number}];
export const getEmbeddedDocumentValidations = (
	engagementId,
	documents,
	embeddedFormBodyTypeIds = undefined,
	validationGroup,
	embeddedDocumentIds = undefined,
	documentGroupId
) => {
	if (documents && documents.length > 0 && embeddedDocumentIds && embeddedDocumentIds.length > 0) {
		const documentIds = documents.map((d) => d.id);
		const validationGroups = [];

		if (validationGroup) {
			validationGroups.push(validationGroup);
		}

		const url = GetAllValidationsUrl(engagementId, {
			...commonValidationParams,
			validationGroups,
			IncludeChildren: false,
			documentGroups: documentGroupId
		});

		return {
			type: types.GET_VALIDATIONCOUNTS,
			documentIds,
			meta: {
				api: {
					url,
					method: 'GET'
				}
			},
			embeddedDocumentIds
		};
	}
};

export const getUnresolvedCommentsCount = (
	engagementId,
	documentId,
	documentTypeId,
	payload,
	embeddedFormBodyTypeIds,
	filteredDocumentIds
) => {
	if (documentId && documentId !== '') {
		const ValidationGroups = getValidationGroup(documentTypeId);
		const filter = loadStorage('validationsFilter');
		if (
			documentTypeId === documentTypes.PROFILEV2 ||
			documentTypeId === documentTypes.INDEPENDENCEFORMINDIVIDUAL ||
			filter === validationFilter.INCOMPLETE ||
			filter === validationFilter.COMMENTS ||
			filter === summaryFilters.INCOMPLETERESPONSES ||
			filter === summaryFilters.UNRESOLVEDCOMMENTS
		) {
			commonValidationParams.hasIncompleteResponse = true;
		} else {
			delete commonValidationParams.hasIncompleteResponse;
		}

		let url = GetFormValidationsUrl(engagementId, documentId, {
			...commonValidationParams,
			ValidationGroups,
			embeddedFormBodyTypeIds
		});

		if (documentTypeId === documentTypes.INDEPENDENCEFORMINDIVIDUAL) {
			url = GetFormValidationsUrl(engagementId, documentId, {
				...commonValidationParams,
				ValidationGroups,
				filteredDocumentIds: filteredDocumentIds?.join(','),
				embeddedFormBodyTypeIds
			});
		}

		return {
			type: types.GET_VALIDATIONCOUNTS,
			documentIds: filteredDocumentIds !== undefined ? [documentId].concat(filteredDocumentIds) : [documentId],
			documentTypeId: documentTypeId,
			...payload,
			meta: {
				api: {
					url,
					method: 'GET'
				}
			}
		};
	}
};

function getValidationGroup(documentTypeId, bodyTypeId) {
	if (documentTypeId === documentTypes.INDEPENDENCEFORMINDIVIDUAL) {
		return ValidationGroup.IndependenceV2Validations;
	} else if (documentTypeId === documentTypes.PROFILEV2) {
		return ValidationGroup.ProfileV2Validations;
	} else if (documentTypeId === documentTypes.IT_FLOW_ISA315) {
		return ValidationGroup.ITFlowCanvasForm;
	} else if (Utility.isDocumentTypeFit(documentTypeId)) {
		if (bodyTypeId === formBodyType.ALRAAccountList) {
			return ValidationGroup.AccountsWithoutIndividualALRADocument;
		} else if (bodyTypeId === formBodyType.DocumentUploadLegend) {
			return ValidationGroup.DocumentsMissingRequiredPICEQRSignOff;
		} else if (bodyTypeId === formBodyType.EstimateListing) {
			return ValidationGroup.EstimatesWithoutIndividualDocument;
		}
		return ValidationGroup.GuidedWorkFlow;
	} else {
		return ValidationGroup.CanvasForm;
	}
}

function getValidationGroups(documentTypeIds, bodyTypeId) {
	let result = [];
	let group;

	for (let i = 0; i < documentTypeIds.length; i++) {
		group = getValidationGroup(documentTypeIds[i], bodyTypeId);

		if (result.indexOf(group) === -1) {
			result.push(group);
		}
	}

	return result;
}
